module.exports = __webpack_public_path__ + "static/media/auto-play-off.66bf6827.svg";